import   { Auth } from "aws-amplify";

export const getAccessToken = async (): Promise<string | undefined> => {
  try { 
      const session = await Auth.currentSession();
      //console.log(session);
      return session?.getAccessToken()?.getJwtToken();
  } catch (error) {
    //The user is not authenticated
    return undefined;
  }
};


export const getUser = async(): Promise<any> => {
  try { 
    const user = await Auth.currentUserInfo();
    return user?.attributes;
} catch (error) {
  //The user is not authenticated
  return undefined;
}
  
}

export const doLogin = async (): Promise<undefined> => {
  try {
    return undefined;
  } catch (error) {
    //The user is not authenticated
    return undefined;
  }
};

export const doLoginConfirm = async (): Promise<undefined> => {
  try {
    return undefined;
  } catch (error) {
    //The user is not authenticated
    return undefined;
  }
};

export const doSignup = async (): Promise<undefined> => {
  try {
    return undefined;
  } catch (error) {
    //The user is not authenticated
    return undefined;
  }
};

export const doLoginWithDetails = async (): Promise<undefined> => {
  try {
    return undefined;
  } catch (error) {
    //The user is not authenticated
    return undefined;
  }
};
